module.exports = __webpack_public_path__ + "img/ホーム.3cea6479.svg";